import React from 'react';
import { poiFilters } from '../../utils/constants';
import './styles/Filters.css';

const FilterBar = ({ activeFilters, onFilterClick, className = '' }) => {
  const handleScroll = (event) => {
    const container = event.target;
    const scrollAmount = event.deltaY;
    container.scrollTo({
      top: 0,
      left: container.scrollLeft + scrollAmount,
      behavior: 'smooth'
    });
  };

  return (
    <div className={`filter-row-wrapper ${className}`}>
      <div className="filter-row" onWheel={handleScroll}>
        {poiFilters.map(filter => (
          <button 
            key={filter.name} 
            className={`filter-btn ${activeFilters.includes(filter.name) ? 'active' : ''}`} 
            onClick={() => onFilterClick(filter.name)}
          >
            <img src={filter.buttonIcon} alt="" /> {filter.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterBar; 